<template>
  <div class="login wh100 flex_center hidden pr">
    <div class="wrap white flex">
      <div class="login_left">
        <img src="@/assets/px_login_left.png" class="login_left_img">
      </div>
      <div class="login_right flex1">
        <ul class="tabList pointer flex_middle">
          <li class="lh36 fs18 c6" :class="{active: activeIndex === 0}" @click="toggleTab(0)">账密登录</li>
          <el-divider direction="vertical" />
          <li class="lh36 fs18 c6" :class="{active: activeIndex === 1}" @click="toggleTab(1)">验证码登录</li>
        </ul>
        <el-form v-if="activeIndex === 0" ref="form" :model="form" :rules="rules" class="login-form">
          <el-form-item prop="account">
            <el-input v-model.trim="form.account" type="text" placeholder="请输入账号" clearable prefix-icon="el-icon-user" @keyup.native.13="next" />
          </el-form-item>
          <el-form-item prop="pass">
            <el-input ref="pass" v-model.trim="form.pass" type="password" placeholder="请输入密码" show-password prefix-icon="el-icon-lock" @keyup.native.13="submitForm('form')" />
          </el-form-item>
          <el-form-item>
            <div class="w100 between">
              <el-checkbox v-model="checked">下次自动登录</el-checkbox>
              <span class="forget c9 pointer" @click="forgetPass">忘记密码</span>
            </div>
          </el-form-item>
          <el-button type="primary" class="login_btn w100 fs18" @click="submitForm('form')">登录</el-button>
        </el-form>
        <el-form v-else ref="codeForm" :model="codeForm" :rules="codeRules" class="login-form">
          <el-form-item prop="account">
            <el-input v-model.trim="codeForm.account" type="text" placeholder="请输入手机号" maxlength="11" clearable prefix-icon="el-icon-mobile" @input="codeForm.account = codeForm.account.replace(/\D/g, '')" />
          </el-form-item>
          <el-form-item prop="code">
            <div class="flex_middle">
              <el-input v-model.trim="codeForm.code" type="text" placeholder="请输入验证码" maxlength="4" clearable prefix-icon="el-icon-message" @input="codeForm.code = codeForm.code.replace(/\D/g, '')" />
              <el-button v-if="!isSend" style="height: 40px;" class="active_color ml20" @click="getCode">{{ str }}</el-button>
              <el-button v-if="isSend" style="height: 40px;" class="ml20" disabled>{{ countStr }}</el-button>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="w100 between">
              <el-checkbox v-model="checked">下次自动登录</el-checkbox>
            </div>
          </el-form-item>
          <el-button type="primary" class="login_btn w100 fs18" @click="submit('codeForm')">登录</el-button>
        </el-form>
        <edit-pass title="修改密码" :visible.sync="editPassDialog" width="400px" @submitEdit="submitEdit" />
      </div>
    </div>
  </div>
</template>

<script>
import EditPass from '@/layout/components/EditPassword'
import { sendsmsCode } from '@/api/common'
import { getCurVersion } from '@/api/user'
import { get, set, clearAll } from '@/utils/storage'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    EditPass
  },
  data() {
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      }
    }
    const validateRegcode = (rule, value, callback) => {
      if (!this.codeForm.account) {
        callback(new Error('请先输入手机号'))
      } else if (!this.code) {
        callback(new Error('请先获取短信验证码'))
      } else if (!value) {
        callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    return {
      isMultiple: false, // 是否多公司
      activeIndex: 0,
      form: {
        account: '',
        pass: ''
      },
      rules: {
        account: [{ required: true, message: '请输入账号', trigger: 'change' }],
        pass: [{ required: true, message: '请输入密码', trigger: 'change' }]
      },
      checked: true,
      codeForm: {
        account: '',
        code: ''
      },
      codeRules: {
        account: [{ required: true, validator: validateMobile, trigger: 'change' }],
        code: [{ required: true, validator: validateRegcode, trigger: 'change' }]
      },
      code: '',
      str: '获取验证码',
      countStr: '重新发送（60s）',
      isSend: false,
      timer: null,
      companyList: [],
      editPassDialog: false
    }
  },
  computed: {
    ...mapGetters('user', ['version', 'updateVersion', 'versionContent', 'nodeAuth'])
  },
  created() {
    // 自动登录
    if (get(process.env.VUE_APP_STORAGE_USERINFO) && get('autoLogin') === 'true') {
      this.routerDump()
    }
  },
  methods: {
    ...mapActions('user', ['smslogin', 'loginFn']),
    ...mapMutations('user', ['SET_UPDATEVERSION', 'SET_VERSIONCONTENT', 'SET_VERSION']),
    next() {
      this.$refs.pass.focus()
    },
    toggleTab(i) {
      this.activeIndex = i
      if (i === 0) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate(['account', 'pass'])
        })
      } else {
        this.$nextTick(() => {
          this.$refs.codeForm.clearValidate(['account', 'code'])
        })
      }
    },
    getCode() {
      this.$refs.codeForm.validateField('account', (err) => {
        if (!err) {
          sendsmsCode({ account: this.codeForm.account }).then(res => {
            if (res.code === 200) {
              this.code = 1
              this.isSend = true
              this.timer = null
              let time = 60
              this.timer = setInterval(() => {
                if (time === 0) {
                  this.str = '重新获取验证码'
                  this.countStr = '重新发送（60s）'
                  this.isSend = false
                  clearInterval(this.timer)
                } else {
                  time--
                  this.countStr = `重新发送（${time}s）`
                }
              }, 1000)
            }
          })
        }
      })
    },
    login(res, type) {
      if (this.timer) { clearInterval(this.timer) }
      if (type === 1 && this.form.pass === '111111') {
        set('pass', 'default')
        this.editPassDialog = true
        return false
      }
      this.routerDump()
    },
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const res = await this.loginFn(this.form)
          if (res.code === 200) {
            if (this.timer) {
              clearInterval(this.timer)
            }
            this.login(res.data, 1)
          }
        } else {
          return false
        }
      })
    },
    submit(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const res = await this.smslogin(this.codeForm)
          if (res.code === 200) {
            if (this.timer) {
              clearInterval(this.timer)
            }
            this.login(res.data, 2)
          }
        } else {
          return false
        }
      })
    },
    async routerDump() {
      const res = await getCurVersion()
      if (res.code === 200) {
        const oldVersion = get('version')
        if (oldVersion && oldVersion.toLowerCase() !== res.data.version.toLowerCase() || !oldVersion) {
          // 更新内容描述
          this.SET_VERSIONCONTENT(res.data.employer_desc)
          // 显示弹框
          this.SET_UPDATEVERSION(true)
          // 本地存储版本号
          set('version', res.data.version)
        }
        set('autoLogin', this.checked) // 自动登录
        set('pass', 'define')
        // 权限列表
        if (this.nodeAuth.length) {
          this.$router.replace('/home')
        } else {
          this.$message.error('暂无任何权限,请联系超级管理员')
          clearAll()
        }
      } else {
        clearAll()
      }
    },
    submitEdit() {
      this.routerDump()
    },
    forgetPass() {
      if (this.timer) { clearInterval(this.timer) }
      this.$router.push({ path: '/findpass' })
    }
  }
}
</script>

<style lang="scss" scoped>
.login{
  min-width: 1260px;
  min-height: 600px;
  background-image: url('../../assets/login_bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .wrap{
    width: 900px;
    height: 480px;
    border-radius: 10px;
    box-shadow: 0 1px 14px 2px rgba(45, 140, 240, 0.09);
    .login_left{
      width: 420px;
      height: 480px;
    }
    .login_left_img{
      width: 100%;
      border-radius: 10px 0 0 10px;
    }
    .login_right{
      padding: 40px 50px;
      .tabList{
        margin: 0;
        margin-bottom: 35px;
        li{
          &.active{
            font-weight: 600;
            color: #333;
            &::after{
              width: 100%;
              height: 2px;
              border-radius: 2px;
              background: #2d8cf0;
              content: "";
              display: block;
              position: relative;
              top: 0px;
              margin: 0 auto;
            }
          }
        }
        .el-divider--vertical{
          margin: 0 18px;
        }
      }
      .login-form{
        .el-input--medium .el-input__inner{
          height: 66px;
          line-height: 66px;
          border: none;
          border-radius: 0;
          border-bottom: 1px solid #e8e8e8;
        }
        .el-input__prefix{
          left: -5px;
        }
        .el-input--medium .el-input__icon{
          font-size: 17px;
          padding-top: 2px;
        }
        .forget{
          &:hover{
            color: #2d8cf0;
          }
        }
        .login_btn{
          height: 46px;
          margin-top: 35px;
        }
      }
    }
  }
}
</style>
